import React from 'react';
import { Tag, Tooltip } from 'antd';
import { MassiveCreator, OWNER_TYPE } from 'services/MassiveService';
import { MassiveScope, MASSIVE_SCOPES } from './options';

interface Props {
  creator?: MassiveCreator | null;
  scope: MassiveScope;
}

const MassiveOriginBadge = ({ creator, scope }: Props) => {
  if (!creator) return null;

  if (
    scope === MASSIVE_SCOPES.STORE &&
    creator.owner_type === OWNER_TYPE.MARKETPLACE
  ) {
    return (
      <Tooltip title="La creó el Marketplace. Sólo ves los paquetes de tu tienda.">
        <Tag color="blue">Creada desde el Marketplace</Tag>
      </Tooltip>
    );
  }

  if (
    scope === MASSIVE_SCOPES.MARKETPLACE &&
    creator.owner_type === OWNER_TYPE.STORE
  ) {
    return <Tag color="geekblue">Creada por una tienda</Tag>;
  }

  return null;
};

export default MassiveOriginBadge;
